module.exports = __webpack_public_path__ + "static/media/schoolpic03@3x.3805b859.png";